module.exports = __webpack_public_path__ + "img/1.917ce9b0.jpg";